<template>
    <v-progress-linear color="primary" v-if="formLoading" indeterminate></v-progress-linear>
    <v-container v-else>
        <v-row>
            <v-col>
                <v-form ref="requiredForm">
                    <div>
                        <div>
                            {{ $t("customer-info.general.input.fullname.title") }} <span class="text-red">&#42;</span>
                        </div>

                        <full-name-field v-model="user.full_name"></full-name-field>
                    </div>
                    <div>
                        <div>
                            {{ $t("customer-info.general.input.email.title") }} <span class="text-red">&#42;</span>
                        </div>
                        <div class="text-caption">{{ $t("customer-info.general.input.email.desc") }}</div>
                        <email-field v-model="user.email"></email-field>
                    </div>
                    <div>
                        <div>
                            {{ $t("customer-info.general.input.retype-email.title") }} <span
                                class="text-red">&#42;</span>
                        </div>
                        <email-field v-model="user.retype_email" :email="user.email"></email-field>
                    </div>
                    <div>
                        <div>
                            {{ $t("customer-info.general.input.hp.title") }} <span class="text-red">&#42;</span>
                        </div>
                        <div class="text-caption">{{ $t("customer-info.general.input.hp.desc") }}</div>
                        <phone-number-field v-model="user.phone"></phone-number-field>
                    </div>
                </v-form>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <template v-for="(cart, index) in modelValue" :key="index">
                    <v-form ref="formRefs">
                        <v-expansion-panels :model-value="formStep == cart.productType.index ? 0 : false"
                            v-if='cart.productType.form'>
                            <v-expansion-panel :disabled="formStep != cart.productType.index" class="my-2 pa-0"
                                elevation="0">
                                <v-expansion-panel-title>
                                    {{ cart.productType.producttype_name }}
                                </v-expansion-panel-title>

                                <v-expansion-panel-text>
                                    <template v-for="(form, iForm) in cart.productType.form" :key="iForm">
                                        <v-card class="my-4" variant="outlined">
                                            <v-card-title>
                                                {{ `${iForm + 1}. ${form.template_name}` }}
                                            </v-card-title>

                                            <v-card-text>
                                                <template v-for="(field, iField) in form.fields" :key="iField">
                                                    <v-card class="mb-3" variant="flat">

                                                        <v-card-text
                                                            v-if="field.infoquestiontype.question_type !== 'seller-data'">
                                                            <div>
                                                                {{ `${iField + 1}. ${field.question}` }}
                                                                <span class="text-red"
                                                                    v-if="!field.is_optional">&#42;</span>
                                                            </div>

                                                            <component :is="mappedFields[field.type]?.component"
                                                                :options="field.options" v-model="field.value"
                                                                :required="!field.is_optional"
                                                                :max-length="field.answer_max_length"
                                                                :limit="field.answer_limit">
                                                            </component>
                                                        </v-card-text>
                                                    </v-card>
                                                </template>
                                            </v-card-text>

                                        </v-card>
                                    </template>

                                    <div class="d-flex justify-end">
                                        <v-btn v-if="formStep != 0" class="me-2 text-none" variant="outlined"
                                            color="widget-color" @click="formStep--">{{
                                                $t("customer-info.general.back") }}</v-btn>
                                        <v-btn @click="validateForm(index)" class="text-none" color="widget-color">{{
                                            $t("customer-info.general.save")
                                            }}</v-btn>
                                    </div>
                                </v-expansion-panel-text>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-form>
                </template>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
import { ref, defineModel, computed, onMounted } from 'vue';
import store from '@/plugins/store';
import api from '@/plugins/api';
import mappedFields from './field/fields';
import EmailField from './field/text/EmailField.vue';
import FullNameField from './field/text/FullNameField.vue';
import PhoneNumberField from './field/text/PhoneNumberField.vue';

const modelValue = defineModel('carts', {
    default: [],
    type: Array,
    required: true
})

const requiredForm = computed({
    get() {
        return store.state.requiredForm
    },
    set(value) {
        store.state.requiredForm = value
    }
})

const user = computed({
    get() {
        return store.state.user
    },
    set(value) {
        store.state.user = value
    }
})


const formCount = computed({
    get() {
        return store.state.formCount
    },
    set(value) {
        store.state.formCount = value
    }
})
const formLoading = computed({
    get() {
        return store.state.loadingForm
    },
    set(value) {
        store.state.loadingForm = value
    }
})

async function init() {

    for (const cartItem of modelValue.value) {
        let qty = cartItem.qty
        let productType = cartItem.productType

        // get form by product type id
        const result = await api.get(`/form/detail/type/${productType.producttype_id}`)
        const response = result.data.response
        const count = response.count

        if (count == 0) continue
        const forms = response.forms
        const form = forms[0]
        const formSellerDataSorting = form.fields.sort((a, b) => {
            // If `question_type` is "seller-data", push it to the bottom
            if (a.infoquestiontype.question_type === "seller-data") return 1;
            if (b.infoquestiontype.question_type === "seller-data") return -1;
            return 0;
        });
        form.fields = formSellerDataSorting
        const fields = form.fields

        if (fields.length == 0) continue
        productType.index = JSON.parse(JSON.stringify(formCount.value))
        if (formStep.value == null) formStep.value = formCount.value
        formCount.value++

        for (const field of form.fields) {
            field.type = field?.infoquestiontype?.question_type
            field.value = mappedFields[field.type]?.defaultValue
        }

        productType.form = [
            // set form
            JSON.parse(JSON.stringify(form))
        ]

        while (--qty) {
            productType.form.push(JSON.parse(JSON.stringify(form)))
        }
    }
}

onMounted(() => {
    formLoading.value = true
    formCount.value = 0
    formStep.value = null
    init().then(() => {
        formLoading.value = false
    })
})

const formRefs = ref()
const formStep = computed({
    get() {
        return store.state.formStep
    },
    set(value) {
        store.state.formStep = value
    }
})

async function validateForm(index) {
    const result = await formRefs.value[index].validate()

    if (result.valid)
        formStep.value++
}
</script>

<style lang="scss" scoped></style>